function RatingDataItems() {
    return (
        <div className="rating-data-item">
          <h4>5000+</h4>
          <p>Happy Customers</p>
        </div>
    )
}

export default RatingDataItems;